import { Box } from '@material-ui/core';

import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface KeyboardShortcutProps {
  command: string;
  label?: string;
  iconName?: string;
  bordered?: boolean;
  style?: React.CSSProperties;
}

export const KeyboardShortcut = ({ command, label, iconName, bordered = false, style }: KeyboardShortcutProps) => {
  const { palette } = useCustomTheme();
  const color = palette.grey[500];

  return (
    <Box display={'flex'} alignItems={'center'}>
      {label && (
        <Font
          variant="caption"
          style={{ color, fontSize: '11px', lineHeight: '0', fontWeight: 500, flexShrink: 0, marginRight: 4 }}
        >
          {label}
        </Font>
      )}
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '2px',
          height: 'max-content',
          width: 'max-content',
          backgroundColor: palette.grey[100],
          borderRadius: '6px',
          padding: '4px 6px',
          ...(bordered && { border: `1px solid ${color}` }),
          ...style,
        }}
      >
        {iconName && (
          <Icon size={12} style={{ color, flexShrink: 0 }}>
            {iconName}
          </Icon>
        )}
        <Font
          variant="caption"
          display="block"
          style={{
            color,
            fontSize: '10px',
            lineHeight: '0',
            fontWeight: 400,
            fontFamily: 'Google Sans Code, monospace',
            flexShrink: 0,
          }}
        >
          {command}
        </Font>
      </Box>
    </Box>
  );
};
